// Promo / sale helpers for products.
// A sale is considered "active" when sale_price > 0 and < price,
// and (now is within [promo_starts_at, promo_ends_at]).
export function getActiveSale(product) {
  if (!product) return null;
  const sp = Number(product.sale_price);
  const price = Number(product.price);
  if (!sp || isNaN(sp) || sp <= 0 || sp >= price) return null;

  const now = Date.now();
  if (product.promo_starts_at) {
    const t = Date.parse(product.promo_starts_at);
    if (!isNaN(t) && now < t) return null;
  }
  if (product.promo_ends_at) {
    const t = Date.parse(product.promo_ends_at);
    if (!isNaN(t) && now > t) return null;
  }
  const pct = Math.round(((price - sp) / price) * 100);
  return {
    sale_price: sp,
    original_price: price,
    percent_off: pct,
    label: product.promo_label || "",
    ends_at: product.promo_ends_at || null,
  };
}

// Returns the price the buyer actually pays right now (sale price if active).
export function effectivePrice(product) {
  const sale = getActiveSale(product);
  return sale ? sale.sale_price : Number(product?.price || 0);
}
